import { render, staticRenderFns } from "./CommonPannel.vue?vue&type=template&id=6848c7d8&scoped=true&"
import script from "./CommonPannel.vue?vue&type=script&lang=js&"
export * from "./CommonPannel.vue?vue&type=script&lang=js&"
import style0 from "./CommonPannel.vue?vue&type=style&index=0&id=6848c7d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848c7d8",
  null
  
)

export default component.exports